import { memo, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "stores";
import store from "stores/interfaces";

import NoteListItem from "./NoteListItem";
import { reorderNotes } from "stores/modules/entities.room.notes/operations";
import SortableList from "containers/SortableList";
import SortableItem from "containers/SortableItem";
import { DropProps } from "stores/modules/firestoreModuleUtils/ordaring";

type NoteListProps = {
  roomId: string;
};

const NoteListContainer = (props: NoteListProps) => {
  const dispatch = useAppDispatch();
  const noteIds = useAppSelector(store.getRoomOrderdNoteIds);

  const onSelect = useCallback(
    (id: string) => {
      dispatch(
        store.appStateMutate((state) => {
          state.selectedNoteId = id;
        })
      );
    },
    [dispatch]
  );
  const onReorder = useCallback(
    (order: DropProps) => {
      dispatch(reorderNotes(props.roomId, order));
    },
    [props.roomId, dispatch]
  );

  return (
    <SortableList
      ids={noteIds}
      sortableItem={(id) => (
        <SortableItem id={id}>
          <NoteListItem noteId={id} />
        </SortableItem>
      )}
      onReorder={onReorder}
      onSelect={onSelect}
    />
  );
};

export default memo(NoteListContainer);
